import { render, staticRenderFns } from "./LogoCard.vue?vue&type=template&id=2464f4c4&scoped=true&"
import script from "./LogoCard.vue?vue&type=script&lang=ts&"
export * from "./LogoCard.vue?vue&type=script&lang=ts&"
import style0 from "./LogoCard.vue?vue&type=style&index=0&id=2464f4c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2464f4c4",
  null
  
)

export default component.exports